
<div class="phone-field" *ngIf="phoneCodes.length>0">
  <nx-dropdown
    [showFilter]="true"
    class="phone-code"
    [formControl]="mobileCode"
    (focus)="_onInputFocus()"
    (focusOut)="_onInputBlur()"
  >
    <nx-dropdown-item
      *ngFor="let item of phoneCodes"
      [value]="'+' + item.value"
      (click)="trackMobilePhone(); setupMobileCodeChangeHandler()"
    >
      {{ "+" + item.value }}
    </nx-dropdown-item>
  </nx-dropdown>

    <input
    class="phone-field-input"
    [deactivateMask]="deactivateMask"
    [nxMask]="phoneMask"
    [separators]="phoneSeparator"
    [dropSpecialCharacters]="true"
    [formControl]="mobilePhone"
    required="true"
    maxlength='15'
    (blur)="trackMobilePhone(); _onInputBlur()"
    (focus)="_onInputFocus()"
    placeholder="{{ 'callMeBack.phoneNumber' | translate }}"
    type="text"
    nxInput
  
  />
</div>


<nx-error 
class="field-error nx-margin-bottom-m"
appearance="text"
*ngIf="errorState"
>
{{'error.errorMessage' | translate}}
</nx-error>